// extracted by mini-css-extract-plugin
module.exports = {"operatorSelector":"styledSelect_operatorSelector__9IRM7"};